import { gql } from '@apollo/client'

export const VerifyAccount = gql`
    mutation VerifyAccount($code: String!, $userId: ID!) {
        verifyAccount(code: $code, userId: $userId)
    }
`

export default VerifyAccount
